<template>
	<div class="color-picker" :class="{ 'color-picker-disabled' : disabled }">
		<div class="btn-group color-picker-group" >
			<div  class="input-group">
				<div  class="input-group-prepend">
					<button class="btn btn-secondary" @click="showPicker()">
						<div class="color-picker-preview-icon" :style="{ backgroundColor : color }"></div>
					</button>
				</div>
				<input  type="text"  :readonly="disabled"  class="form-control" v-model="color">
			</div>
			<div class="color-picker-dropdown" v-if="show" v-clickaway="hidePicker">
				<colorpicker v-model="color"></colorpicker>
			</div>
		</div>
	</div>
</template>
<script>
import colorpicker from '@/assets/vendor/colorpicker/Index.vue'
export default {
	name : 'VueColorPicker',
	props:{
		value : {
			type : String,
			required : true
		},
		disabled :{
			type : Boolean,
			default : false,
		},
	},
	components:{
		colorpicker
	},
	data(){
		return {
			show : false,
		}
	},
	computed:{
		color : {
			get(){
				return this.value
			},
			set(value){
				this.$emit('input', value)
			}
		}
	},
	methods:{
		showPicker(){
			if( this.disabled ) return;
			this.show = !this.show 
		},
		hidePicker(){
			this.show = false
		}
	},
}
</script>
<style lang="scss" scope>
	.color-picker{
		display: flex;
		width: 100%;
		&-disabled{
			pointer-events: none;
			.color-picker{
				&-group{
					.form-control{
						background-color: #F4F6F8;
						border-color: #DFE4E8;
						color: #C4CDD5;
						&:focus {
							border-color: #DFE4E8;
						}
					}
					.btn{
						background-color: #F4F6F8;
						border-color: #DFE4E8;
						color: #C4CDD5;
					}
				}
			}
		}
		&.is-invalid{
			.color-picker{
				&-group{
					.form-control{
						border-color: $red;
						background-color: #fbeae5;
						&:focus {
							border-color: $danger;
							box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25);
						}
					}
					.btn{
						border-color: $red;
						background-color: #fbeae5;
					}
				}
			}
			
		}
		&-group{
			position: relative;
			.btn{
				background: #fff;
				&:hover{
					background: #fff;
				}
				&:focus{
					background: #fff;
				}
			}
			&.show{
				.color-picker-preview{
					box-shadow: 0 0 0 3px rgba(216,217,219,.5);
				}
			}
		}
		&-preview{
			width: 100%;
			height: 36px;
			display: flex;
			align-items: center;
			flex-direction: row;
			flex-wrap: nowrap;
			
			&-icon{
				width: 22px;
				height: 22px;
				border-radius: 50%;
				border: 1px solid #ddd;
			}
			&-text{
				flex-basis: 0;
				flex-grow: 1;
				max-width: 100%;
				height: 22px;
				padding-left: 8px;
				font-weight: 600;
				font-size: 13px;
				line-height: 18px;
				display: flex;
				align-items: center;
				color: #92929C;
				input{
					width: 100%;
					border: none;
					background: transparent;
				}
			}
		}
		.color-picker-dropdown{
			padding: 0;
			border: 1px solid #D4D4D4;
			box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.18);
			position: absolute;
			top: 100%;
			left: 0;
			margin-top: 10px;
			min-width: 200px;
			z-index: 1000;
			border: 1px solid $border;
			filter: drop-shadow(0 0 10px rgba(0,0,0,0.2));
			&:after,
			&:before {
				content: '';
				display: block;
				position: absolute;
				left: 15px;
				width: 0;
				height: 0;
				border-style: solid;
			}
			&:before {
				top: -20px;
				border-color:  transparent  transparent $border transparent ;
				border-width: 10px;
			}
			&:after {
				top: -18px;
				border-color:   transparent transparent #fff transparent ;
				border-width: 10px;
			}
		}
	}
</style>